<template>
  <div class="login-body">
    <!-- <div class="title">总注册人数：{{body}}人</div> -->
        <studyTable :tableData="tableDataTemp" :columns="columns" :num="num" :pages="pages" ></studyTable>

  </div>
</template>
<script>
import studyTable from "./module/_studyTable";
export default {
  data() {
    return {
      choose: 0,
      tableData: [],
      columns: [
        { name: "注册对象", prop: "areaname" },
        { name: "注册人数", prop: "count" },
        { name: "党员", prop: "State1Count" },
        { name: "群众人数", prop: "State0Count" },
      ],
      tableDataTemp:[],
      pages:1,
      num:1,
    };
  },
  methods: {
    toggle(value) {
      this.choose = value;
    },
    getMsg(){
      this.axios.post(
        '/api/Statistics/Registration',
        {
          c1roleid:sessionStorage.getItem('roleid'),
          c2name:sessionStorage.getItem('token'),
          c2town:sessionStorage.getItem('town'),
          c1status:sessionStorage.getItem('status')
        }
      ).then(e=>{
        console.log(e.data);
        switch (e.data.code) {
          case 0:
            this.tableData = e.data.msg;
            this.num = this.tableData.length
              this.tableData.some((item, index) => {
                if (index == 10) return true;
                else {
                  this.tableDataTemp.push(item)
                }
              });
              this.pages = Number.parseInt(this.tableData.length%10>0?this.tableData.length/10+1:this.tableData.length/10);
            break;
        
          default:
            break;
        }
      })
    }
  },
  components: {
    studyTable
  },
  mounted(){
    this.getMsg()
  }
};
</script>
<style lang='scss' scoped>
.login-body {
  .statistics-msg {
  }
  .title {
    font-size: 0.32rem;
    line-height: 3;
    background: #fff;
    width: 90%;
    margin: 0.3rem auto;
    box-shadow: 0px 0.04rem 0.16rem 0px rgba(0, 0, 0, 0.08);
    border-radius: 0.08rem;
    text-align: center;
  }
  .choose {
    margin-top: 0.1rem;
    display: flex;
    align-items: center;
    background: #fff;
    span {
      width: 50%;
      text-align: center;
      color: #999999;
      line-height: 3;
    }
    .choosed {
      color: #ffa000;
      font-weight: bold;
    }
    box-shadow: 0px 0.06rem 0.06rem 0px rgba(0, 0, 0, 0.06);
  }
  padding-top: 0.9rem;
  font-size: 0.3rem;
  background: #fff;
  min-height: 100vh;
}
</style>